<style scoped>
.el-collapse-item__header {
  padding-left: 15px;
}
.el-upload--picture-card {
  float: left;
  margin-right: 10px;
}
.circle-closesty {
  position: relative;
  top: -35px;
  margin-left: 112px;
  font-size: 20px;
  cursor: pointer;
}
.v-modal {
  z-index: 100 !important;
}
.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}
.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}
.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}
/deep/.el-date-editor .el-range__icon{
  margin-left: 5px;
}
/deep/ .el-table-column--selection .cell{
  padding-right:10px
}
.singe-line {
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  white-space: nowrap;
}
/deep/ .el-table th.el-table__cell>.cell .el-tooltip {
  white-space:nowrap !important;
  text-overflow:ellipsis!important;
  word-break:break-all;
  /* text-wrap:nowrap !important; */
}


</style>
<template>
  <div class="content">
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="8"
          ><div class="search-area-div">选择问卷</div>
          <el-select v-model="page.surveyTenantGuid" filterable placeholder="请选择" class="ipt-sty" >
            <el-option
              v-for="item in surveyList"
              :key="item.guid"
              :label="item.surveyTitle"
              :value="item.guid"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="8" >
          <div class="search-area-div">填写时间</div>
          <el-date-picker
            v-model="timeRange"
            type="daterange"
            align="center"
            unlink-panels
            range-separator="-"
            start-placeholder="起始时间"
            end-placeholder="截止时间"
            value-format="yyyy-MM-dd"
            class="ipt-sty"
          >
          </el-date-picker>
        </el-col>
        <el-col :span="6" class="t-right">
          <el-button size="mini" type="info" @click="goSearch">搜索</el-button>
          <el-button size="mini" @click="emptySearch">清空</el-button>
        </el-col>
      </el-row>
    </div>
    
    <div v-if="surveyList.length>0" class="back-color-fff content-main-box" :style="'height:' + contentMainHeight + 'px;'">
      <div class="button-area">
        <!-- <el-button size="medium" type="info" @click="toImport">批量导入</el-button> -->
        <el-button size="mini" type="info" @click="report">批量导出</el-button>
        <el-button size="mini"  @click="delData(1,'')">批量删除</el-button>
      </div>
      <el-table 
        
       :data="tableData.data&&tableData.data.records"
       stripe border :height="tableHeight" 
       ref="filterTable"
       tooltip-effect="light"
       style="width: 100%" 
       v-loading="tableLoading" 
       @selection-change="handleSelectionChange">
        <!-- selection -->
        <el-table-column type="selection" width="40" header-align="center" align="center" fixed="left"></el-table-column>
        <el-table-column label="序号" width="60" header-align="center" align="center" fixed="left" v-if="tableData.columns">
          <template slot-scope="scope">
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column 
          :prop="'column_'+index" 
          min-width="120" :label="item" 
          show-overflow-tooltip 
          header-align="left" 
          align="left" 
          v-for="(item,index) in tableData.columns" 
          :key="item">
          <!-- <template slot-scope="scope">{{ scope.row.tenantName }}</template> -->
          <template slot="header" >
            <el-tooltip :disabled="isShowTooltip" :content="item" effect="light" placement="top">
              <!-- 单行省略样式、鼠标移入事件 -->
              <div class="singe-line" @mouseover="onMouseOver($event.target)">{{ item }}</div>
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            {{ scope.row['column_' + index] || '-' }}
          </template>
        </el-table-column>
        <el-table-column prop="customerGuid" width="60" label="操作" fixed="right" header-align="center" align="center">
          <template slot-scope="scope">
            <span class="txt-color" @click="delData(2,scope.row.guid)"> 删除 </span>
          </template>
        </el-table-column>
      </el-table>
      
      <el-pagination
        class="pt pb back-color-fff"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10,20,50, 100, 200]"
        :current-page="page.pageIndex"
        :page-size="page.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.totalRows"
      >
      </el-pagination>
    </div>
    <div v-else class="back-color-fff content-no-data" :style="'height:' + contentMainHeight + 'px;'">
      <img src="../../assets/no_data.png" alt="">
      <span>暂无数据</span>
    </div>
  </div>
</template>

<script>
import { route } from '@/api/apiRoute';
import store from '@/store';
import qs from 'qs';
export default {
  data() {
    return {
      tableHeight: window.innerHeight - 264,
      contentMainHeight: window.innerHeight - 150,
      isShowTooltip :false,
      fullscreenLoading: false,
      timeRange:[],
      tableLoading:false,
      page: {
        curTenantGuid: localStorage.guid,
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        surveyTenantGuid:null,
        tenantGuid:"",
        staffGuid:'',
        startTime:'',
        endTime:'',
        taskDetailGuid:null
      },
      multipleSelection:[],
      surveyList:[],
      surveyGuid:null,
      height: window.innerHeight - 260,
      right: 'right',
      tableData: [],
      dialogVisible: false,
      //批量导入
      showImport: false,
      currentStep: 0,
      importResult: '',
      importLoading: false,
      fileList: [], //上传的文件
    };
  },
  created() {
    // this.getList();
    this.getSurveyList();
  },
  watch: {},
  methods: {
    toImport(){
      this.$router.push(`/surveyExport?productGuid=${this.$route.query.productGuid}&guid=${this.$route.query.guid}&surveyGuid=${this.page.surveyTenantGuid || ''}&taskDetailGuid=${this.$route.query.taskDetailGuid}`)
    },
    onMouseOver(target) {
      if (target.scrollWidth > target.clientWidth) {
        this.isShowTooltip = false;
      } else {
        this.isShowTooltip = true;
      }
    },
    //获取问卷列表
    getSurveyList() {
      let self = this;
      self.tableLoading = true;
      let userInfo = JSON.parse(localStorage.userInfo)
      let query = {
        pageIndex: 1,
        pageSize: -1,
        // organisationGuid:userInfo.organisationGuid,
        // tenantGuid: localStorage.guid,
        staffGuid:userInfo.staffGuid,
        taskDetailGuid:this.$route.query.taskDetailGuid
      }
      self.api.postJson(`/${serverConfig.msSalesPerformService}/survey/done-list-by-task`, query).then((res) => {
        self.tableLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          if(res.data.data.records&&res.data.data.records.length>0){
            self.surveyList = res.data.data.records;
            self.page.surveyTenantGuid = self.surveyList[0].guid;
            this.getList()
          }else{
            self.surveyList =  [];
          }
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    goSearch(){
      if(!this.surveyList.length){
        this.$message.error('暂无问卷')
        return
      }
      this.getList()
    },
    getList() {
      let self = this;
      self.tableLoading = true;
      self.page.tenantGuid = localStorage.guid;
      self.page.staffGuid = JSON.parse(localStorage.userInfo).staffGuid;
      this.page.taskDetailGuid = this.$route.query.taskDetailGuid;
      if(this.timeRange.length>0){
        this.page.startTime = this.timeRange[0];
        this.page.endTime = this.timeRange[1];
      }
      self.api.postJson(`/${serverConfig.msSalesPerformService}/survey/import/done-list/get`, this.page).then((res) => {
        
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data;
          self.page.totalPage = res.data.data.data.totalPages;
          self.page.totalRows = res.data.data.data.totalRows;
          self.tableLoading = false;
          this.$nextTick(() => {
            this.$refs.filterTable.doLayout();
          });
        } else {
          self.tableLoading = false;
          self.$message.error(res.data.msg);
        }
      });
    },
    emptySearch() {
      if(!this.surveyList.length){
        this.$message.error('暂无问卷')
        return
      }
      this.page = {
        pageIndex: 1,
        pageSize: 50,
        totalPage: 0,
        totalRows: 0,
        surveyTenantGuid:this.page.surveyTenantGuid,
        tenantGuid:"",
        staffGuid:'',
        startTime:'',
        endTime:'',
        taskDetailGuid:this.page.taskDetailGuid
      };
      this.timeRange = [];
      this.getList();
    },
    report() {
      let self = this;
      self.fullscreenLoading = true;
      let query = JSON.parse(JSON.stringify(this.page));
      query.pageSize = -1;
      self.api.postJson(`/${serverConfig.msSalesPerformService}/survey/export/done-list`, query).then((res) => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.reportJx(res.data.data.colNames, res.data.data.datas, res.data.data.sheetName, res.data.data.fileNam);
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    reportJx(colNames, datas, sheetName, fileNam) {
      let self = this;
      self.api
        .postJsonD(`/${serverConfig.msCommonAdminCloudService}/excel/export`, {
          colNames: colNames,
          datas: datas,
          sheetName: sheetName,
          fileNam: fileNam,
        })
        .then((res) => {
          let blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
          let fileName = fileNam;
          let objectUrl = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.download = fileName;
          link.href = objectUrl;
          link.click();
          self.fullscreenLoading = false;
        });
      self.empty();
    },
    //新增
    addVersion() {
      let path = '/questionnaireAdd';
      let query = {};
      if (this.$route.query.productGuid) {
        query.productGuid = this.$route.query.productGuid;
      }
      this.$router.push({
        path,
      });
    },
    // 批量删除
    delData(flg, guid) {
      let that = this;
      console.log('556',that.multipleSelection);
      
      if(flg == 1 && that.multipleSelection.length == 0){
        return  that.$message.error("请勾选数据！");
      }

      if(flg == 2) {
        that.multipleSelection = [];
        that.multipleSelection.push(guid);
      }
      that.tableLoading = true;
      //删除之前调接口校验
      this.api.get(`/${serverConfig.msCommonImportDataService}/import-data/check-finish?importType=0037&staffGuid=${JSON.parse(localStorage.userInfo).staffGuid}`).then((resp) => {
        that.tableLoading = false;
        console.log('res',resp.data.code == serverConfig.REQUIRE_SUCCESS_CODE)
        if (resp.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          that.$confirm('此操作将永久删除, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            that.tableLoading = true;
            // deletels加了时间限制
            that.api.postJson(`/${serverConfig.msSalesPerformService}/survey/staff/delete`, that.multipleSelection)
            .then((res) => {
              that.tableLoading=false
              if(res.data.code == serverConfig.REQUIRE_SUCCESS_CODE){
                that.$message.success('删除成功');
                that.multipleSelection = [];
                this.getList()
              }else {
                that.$message.error(res.data.msg);
              }
            }) 
          }).catch(() => {
            that.$message({
              type: 'info',
              message: '已取消删除'
            });
          });
        } else {
          that.$confirm(resp.data.msg, '提示', {
            confirmButtonText: '好的，我知道了',
            showCancelButton: false,
            type: 'warning',
          })
          .then(() => {
            that.multipleSelection = [];
          })
        }
      });
    },
    // delData(flg, guid) {
    //   let that = this;
    //   console.log('556',that.multipleSelection);
      
    //   if(flg == 1 && that.multipleSelection.length == 0){
    //     return  that.$message.error("请勾选数据！");
    //   }

    //   if(flg == 2) {
    //     that.multipleSelection = [];
    //     that.multipleSelection.push(guid);
    //   }
    //   let arr,arr1, arr2, arr3, arr4;
    //   let length=that.multipleSelection.length;
    //   // if (length > 4) {
        
    //   //   arr1 = that.multipleSelection.slice(0, Math.round(length / 4));
    //   //   arr2 = that.multipleSelection.slice(Math.round(length / 4), Math.round(length / 4) * 2);
    //   //   arr3 = that.multipleSelection.slice(Math.round(length / 4) * 2, Math.round(length / 4) * 3);
    //   //   arr4 = that.multipleSelection.slice(Math.round(length / 4) * 3);
        
    //   //   arr=[arr1, arr2, arr3]
    //   //   arr4.length?arr.push(arr4):arr;
    //   // }
    //   // console.log('arr1',arr1.length,arr2.length,arr3.length,arr4.length);
      
    //   this.$confirm('此操作将永久删除, 是否继续?', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   }).then(() => {
    //     that.tableLoading = true;
    //     if(length>4){
    //       const AllPromises = (arr).map((guids) => {
          
    //       return new Promise((resolve,reject) => {
    //         that.api.postJson(`/${serverConfig.msSalesPerformService}/survey/staff/delete`, guids).then((res) => {
    //           if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                
    //             resolve(true);
    //           } else {
    //             reject(new Error(res.data.msg))
    //           }
    //         });
    //       });
    //       });
    //       Promise.all(AllPromises).then((res) => {
    //         that.tableLoading = false;
    //         that.multipleSelection = [];
    //         that.$message.success('删除成功');
    //         this.getList()
    //       }).catch((err) => {
    //         that.tableLoading = false;
    //         that.multipleSelection = [];
    //         that.$message.error(err);
    //         this.getList()
    //       });
    //     }else{
    //       that.api.postJson(`/${serverConfig.msSalesPerformService}/survey/staff/delete`, that.multipleSelection)
    //       .then((res) => {
    //         that.tableLoading=false
    //         if(res.data.code == serverConfig.REQUIRE_SUCCESS_CODE){
              
    //           that.$message.success('删除成功');
              
    //           that.multipleSelection = [];
              
                
    //           this.getList()
              
    //         }else {
    //           that.$message.error(res.data.msg);
    //         }
    //       }) 

    //     }
        
        
        
    //   }).catch(() => {
    //     that.tableLoading = false;
    //     this.$message({
    //       type: 'info',
    //       message: '已取消删除'
    //     });
    //   });
    // },
    // 右边列表的多选
    handleSelectionChange(val){
      this.multipleSelection = [];
      
      val.forEach((item)=>{
        this.multipleSelection.push(item.guid)
      })
      // console.log('vv',this.multipleSelection);
    },
    
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getList();
    },

  },
};
</script> 
<style lang="less" scoped>
.content h1 {
  margin: 0;
  margin-bottom: 16px;
  font-size: 18px;
}
.content-no-data{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  font-size: 14px;
  color: #b2b2b2;
  img{
    width: 168px;
    height: 96px;
  }
  // span{
  //   font-size: 14px;
  //   color: #b2b2b2;
  // }
}
.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}
.el-range-editor.el-input__inner {
  padding: 0px;
}
/deep/ .el-checkbox__label {
  display: none;
}
.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}
.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}
/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}
/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}
/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}
/* 导入 */
.importClass .firstStep {
  text-align: left;
  margin-top: 50px;
}

.importClass .firstStep .el-row {
  margin-bottom: 50px;
}

.importClass .firstStep .el-col-6 {
  text-align: right;
}

.importClass .firstStep .tipInfo {
  line-height: 26px;
  color: #999;
  margin-top: 10px;
}

.importClass .secondStep {
  margin-top: 50px;
  height: 290px;
}

.importClass .secondStep .line1 {
  font-size: 20px;
}

.importClass .secondStep .line2 {
  font-size: 16px;
}

.importClass .secondStep .line2 span {
  color: #4fa1a4;
}

.importClass .secondStep .line3 {
  text-decoration: underline;
  cursor: pointer;
}
.downloadTemplate {
  color: #fff;
  background: #4fa1a4;
  padding: 9px 15px;
  border-radius: 3px;
  display: inline-block;
}
.survey-state-yes{
  display: inline-block;
  width: 56px;
  height: 24px;
  color: #649FA4;
  font-size: 12px;
  background: rgba(234, 246, 247, 0.39);
  border: 1px solid #B0D0D3;
  border-radius: 2px;
}
.survey-state-no{
  display: inline-block;
  width: 56px;
  height: 24px;
  color: #FF2121;
  font-size: 12px;
  background: rgba(255, 244, 244, 0.39);
  border: 1px solid #FFDEDE;
  border-radius: 2px;
}
/deep/.el-progress{
  display: flex;
}
/deep/.el-progress__text{
  flex-shrink: 0;
}
.search-area-div {
  width: 62px;
  text-align: right;
  /* flex-shrink: 0; */
}
.ipt-sty {
  flex: 1;
}
.el-col-6 {
  margin-bottom: 8px;
  display: flex;
}
.el-col-8 {
  display: flex;
  /* margin-bottom: 15px; */
}
</style>